import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import {
  type AICoachVisibilityState,
  getAiCoachPromoState,
} from '@lyrahealth-inc/shared-app-logic/src/features/messaging/utils'
import { type MessageConversation } from '@lyrahealth-inc/shared-app-logic/src/models/messages/Messages'

import { getAICoachConversations } from '../../data/lyraTherapy/lyraTherapySelectors'

export const useShouldShowAICoach = (): AICoachVisibilityState => {
  const { isAiCoachEnabled } = useFlags()
  const aiCoachConversations: MessageConversation[] = useSelector(getAICoachConversations)?.toJS() ?? []
  return getAiCoachPromoState({
    conversations: aiCoachConversations,
    isAiCoachEnabled,
  })
}
